<template>
  <div class="popup-wrapper">
    <div class="content-wrapper" :class="{ 'nt-active': statusNT }">
      <div class="content" :class="{ [theme]: true }">
        <div
          class="section-wrapper"
          :class="{
            'single-wrapper': sectionType !== 0,
            'single-video-wrapper': sectionType === 4,
            'non-active': ifMobileReqest
          }"
        >
          <section v-if="sectionType === 0" class="welcome-section">
            <Carousel
              :per-page="perPage"
              :navigationEnabled="navigation"
              :paginationEnabled="pagination"
              :loop="true"
              v-model="page"
              :navigate-to="page"
              navigationNextLabel="<span class='rightnav'></span>"
              :navigationPrevLabel="
                `<div><span class='leftnav'></span><span class='count'> ${page +
                  1} / ${videos.length}</span></div>`
              "
            >
              <Slide
                v-for="(video, index) in videos"
                class="slide"
                :key="index"
              >
                <Video
                  v-if="video.url && videoLoad"
                  @onError="onError"
                  @changeType="changeType"
                  :data="video"
                  :spotlights="[
                    'odometer',
                    'wheel',
                    'headlight',
                    'tire',
                    'navigation',
                    'trunk'
                  ]"
                  :videos_length="videos.length"
                  :images_length="images.length"
                  @onPlay="onPlay"
                  @onNTChange="changeNTStatus"
                  :index="index"
                />
                <div @click="goToSingleVideo(index)" class="play-button">
                  <Play />
                </div>
                <h3 class="title">Audi KE 55s</h3>
              </Slide>
            </Carousel>
            <!-- <div class="section-button-wrapper">
              <div class="button-item" @click="changeType(1)">
                HD Videos({{ videos.length }})
              </div>
              <div class="button-item" @click="changeType(2)">360 Spin</div>
              <div class="button-item" @click="changeType(3)">
                Photos({{ images.length }})
              </div>
            </div> -->
          </section>
          <section v-if="sectionType === 1" class="videos-type">
            <div class="section-title">
              <span @click="changeType(0)"><Back /></span>
              <h2 class="title">Audi A8</h2>
            </div>
            <vue-custom-scrollbar>
              <div class="video-wrapper">
                <div
                  class="item"
                  v-for="(video, index) in videos"
                  :key="index"
                  @click="goToSingleVideo(index)"
                >
                  <video playsinline ref="search-item">
                    <source :src="video.url" type="video/mp4" />
                  </video>
                  <span class="play"></span>
                  <h2 class="title">Audi A8</h2>
                </div>
              </div>
            </vue-custom-scrollbar>
          </section>
          <section v-if="sectionType === 2" class="spinner-type">
            <div class="section-title">
              <span @click="changeType(0)"><Back /></span>
              <h2 class="title">Audi A8</h2>
            </div>
            <vue-three-sixty
              :amount="36"
              imagePath="https://scaleflex.cloudimg.io/width/600/q35/https://scaleflex.ultrafast.io/https://scaleflex.airstore.io/demo/chair-360-36"
              fileName="chair_{index}.jpg?v1"
            />
          </section>
          <section v-if="sectionType === 3" class="images-type">
            <div class="section-title">
              <span @click="changeType(0)"><Back /></span>
              <h2 class="title">Audi A8</h2>
            </div>
            <vue-custom-scrollbar>
              <div class="image-wrapper">
                <div
                  class="item"
                  @click="goToSingleImage(index)"
                  v-for="(image, index) in images"
                  :key="index"
                  :style="{ backgroundImage: 'url(' + image + ')' }"
                ></div>
              </div>
            </vue-custom-scrollbar>
          </section>
          <section v-if="sectionType === 4" class="single-video">
            <span @click="changeType(1)" class="arrow-back"><Back /></span>
            <Carousel
              :per-page="perPage"
              :navigationEnabled="navigation"
              :paginationEnabled="pagination"
              :loop="true"
              v-model="page"
              :navigate-to="page"
              navigationNextLabel="<span class='rightnav'></span>"
              :navigationPrevLabel="
                `<div><span class='leftnav'></span><span class='count'>${page +
                  1} / ${videos.length}</span></div>`
              "
            >
              <Slide
                v-for="(video, index) in videos"
                class="slide"
                :key="index"
              >
                <Video
                  v-if="video.url && videoLoad"
                  @onError="onError"
                  @changeType="changeType"
                  :data="video"
                  :play="index === page ? true : false"
                  :spotlights="[
                    'odometer',
                    'wheel',
                    'headlight',
                    'tire',
                    'navigation',
                    'trunk'
                  ]"
                  :videos_length="videos.length"
                  :images_length="images.length"
                />
                <h3 class="title">Audi KE 55s</h3>
              </Slide>
            </Carousel>
          </section>
          <section v-if="sectionType === 5" class="single-image">
            <span @click="changeType(3)" class="arrow-back"><Back /></span>
            <div class="slider-wrap">
              <Carousel
                :per-page="perPage"
                :navigationEnabled="true"
                :paginationEnabled="false"
                :loop="true"
                v-model="imagePage"
                :navigate-to="imagePage"
                navigationNextLabel="<span class='rightnav'></span>"
                :navigationPrevLabel="
                  `<div><span class='leftnav'></span><span class='count'>${imagePage +
                    1} / ${images.length}</span></div>`
                "
              >
                <Slide
                  v-for="(url, index) in images"
                  class="slide"
                  :key="index"
                >
                  <div
                    class="image-wrapper"
                    :style="{ backgroundImage: 'url(' + url + ')' }"
                  ></div>
                </Slide>
              </Carousel>
              <div class="single-image-navigation">
                {{ imagePage + 1 }} / {{ images.length }}
              </div>
            </div>
          </section>
        </div>
        <div class="more-info" :class="{ active: ifMobileReqest }">
          <vue-custom-scrollbar>
            <span @click="ifMobileReqest = false" class="back"><Back /></span>
            <div
              class="content-info-wrapper"
              :class="{ 'non-active': ifSubmitSuccess }"
            >
              <div class="title">Request more info</div>
              <div class="description">
                Enter your contact information and one of our representatives
                will get back to you with more information about this vehicle.
              </div>
              <div class="contact_from">
                <form @submit.prevent="submitForm">
                  <input
                    class="form-input"
                    type="text"
                    name="first_name"
                    placeholder="First name"
                    v-model="first_name"
                  />
                  <input
                    class="form-input"
                    type="text"
                    name="last_name"
                    placeholder="Last name"
                    v-model="last_name"
                  />
                  <input
                    class="form-input"
                    type="email"
                    name="email"
                    placeholder="Email"
                    v-model="email"
                  />
                  <input
                    class="form-input"
                    type="tel"
                    name="phone_number"
                    placeholder="Phone number"
                    v-model="phone"
                  />
                  <textarea
                    placeholder="Comment"
                    name="comment"
                    v-model="comment"
                    class="form-comment"
                  ></textarea>
                  <button type="submit" class="submit-button">Submit</button>
                </form>
              </div>
            </div>
            <div class="success-wrapper" v-if="ifSubmitSuccess">
              <span class="success-icon"><Success /></span>
              <h2 class="title">Thanks for your request</h2>
              <p class="description">
                Thank you for submitting the request. A representative will
                contact you shortly.
              </p>
              <button class="submit-success" @click="ifSubmitSuccess = false">
                OK
              </button>
            </div>
          </vue-custom-scrollbar>
        </div>
        <h2 class="mobile-title">Audi A8</h2>
        <div class="cross-wrapper" @click="closePlayer">
          <div class="cross"></div>
        </div>
        <div class="mobile-request">
          <button @click="ifMobileReqest = true" class="mobile-request-button">
            Request More Info
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vueCustomScrollbar from "vue-custom-scrollbar";
import "vue-custom-scrollbar/dist/vueScrollbar.css";
import { Carousel, Slide } from "vue-carousel";
import Video from "../components/Video.vue";
import Back from "../components/icons/Back.vue";
import Play from "../components/icons/Play.vue";
import Success from "../components/icons/Success.vue";

export default {
  props: {
    theme: {
      type: String,
      default: "dark",
      required: false
    }
  },
  name: "player",
  components: {
    vueCustomScrollbar,
    Carousel,
    Slide,
    Video,
    Back,
    Play,
    Success
  },
  data() {
    return {
      perPage: 1,
      navigation: true,
      pagination: false,
      first_name: "",
      last_name: "",
      comment: "",
      email: "",
      phone: "",
      sectionType: 0, // define what to show spin, videos or images
      videos: [
        {
          url:
            "https://j6k6k3v9.ssl.hwcdn.net/cjreno/J7576724_2018_Kia_Soul.mp4",
          thumbnails:
            "https://picture.lesautomotive.com/member/Automobile/173/J7576724.vtt",
          cc: "http://testing.lesautomotive.com/T34135_2021_Ford_Explorer.vtt"
        },
        {
          url:
            "https://j6k6k3v9.ssl.hwcdn.net/cjreno/J7576724_2018_Kia_Soul.mp4",
          thumbnails:
            "https://picture.lesautomotive.com/member/Automobile/173/J7576724.vtt",
          cc: "http://testing.lesautomotive.com/T34135_2021_Ford_Explorer.vtt"
        }
      ],
      images: [
        "https://m8g3z9g9.ssl.hwcdn.net/photos/2340/1050J1/1050J1_001.jpg",
        "https://m8g3z9g9.ssl.hwcdn.net/photos/2340/1050J1/1050J1_002.jpg",
        "https://m8g3z9g9.ssl.hwcdn.net/photos/2340/1050J1/1050J1_003.jpg",
        "https://m8g3z9g9.ssl.hwcdn.net/photos/2340/1050J1/1050J1_004.jpg",
        "https://m8g3z9g9.ssl.hwcdn.net/photos/2340/1050J1/1050J1_005.jpg",
        "https://m8g3z9g9.ssl.hwcdn.net/photos/2340/1050J1/1050J1_006.jpg",
        "https://m8g3z9g9.ssl.hwcdn.net/photos/2340/1050J1/1050J1_007.jpg",
        "https://m8g3z9g9.ssl.hwcdn.net/photos/2340/1050J1/1050J1_008.jpg",
        "https://m8g3z9g9.ssl.hwcdn.net/photos/2340/1050J1/1050J1_009.jpg",
        "https://m8g3z9g9.ssl.hwcdn.net/photos/2340/1050J1/1050J1_010.jpg",
        "https://m8g3z9g9.ssl.hwcdn.net/photos/2340/1050J1/1050J1_011.jpg",
        "https://m8g3z9g9.ssl.hwcdn.net/photos/2340/1050J1/1050J1_012.jpg",
        "https://m8g3z9g9.ssl.hwcdn.net/photos/2340/1050J1/1050J1_013.jpg",
        "https://m8g3z9g9.ssl.hwcdn.net/photos/2340/1050J1/1050J1_014.jpg",
        "https://m8g3z9g9.ssl.hwcdn.net/photos/2340/1050J1/1050J1_015.jpg",
        "https://m8g3z9g9.ssl.hwcdn.net/photos/2340/1050J1/1050J1_016.jpg",
        "https://m8g3z9g9.ssl.hwcdn.net/photos/2340/1050J1/1050J1_017.jpg",
        "https://m8g3z9g9.ssl.hwcdn.net/photos/2340/1050J1/1050J1_018.jpg",
        "https://m8g3z9g9.ssl.hwcdn.net/photos/2340/1050J1/1050J1_019.jpg",
        "https://m8g3z9g9.ssl.hwcdn.net/photos/2340/1050J1/1050J1_020.jpg",
        "https://m8g3z9g9.ssl.hwcdn.net/photos/2340/1050J1/1050J1_021.jpg",
        "https://m8g3z9g9.ssl.hwcdn.net/photos/2340/1050J1/1050J1_022.jpg",
        "https://m8g3z9g9.ssl.hwcdn.net/photos/2340/1050J1/1050J1_023.jpg",
        "https://m8g3z9g9.ssl.hwcdn.net/photos/2340/1050J1/1050J1_024.jpg",
        "https://m8g3z9g9.ssl.hwcdn.net/photos/2340/1050J1/1050J1_025.jpg",
        "https://m8g3z9g9.ssl.hwcdn.net/photos/2340/1050J1/1050J1_026.jpg",
        "https://m8g3z9g9.ssl.hwcdn.net/photos/2340/1050J1/1050J1_027.jpg",
        "https://m8g3z9g9.ssl.hwcdn.net/photos/2340/1050J1/1050J1_028.jpg",
        "https://m8g3z9g9.ssl.hwcdn.net/photos/2340/1050J1/1050J1_029.jpg",
        "https://m8g3z9g9.ssl.hwcdn.net/photos/2340/1050J1/1050J1_030.jpg",
        "https://m8g3z9g9.ssl.hwcdn.net/photos/2340/1050J1/1050J1_031.jpg",
        "https://m8g3z9g9.ssl.hwcdn.net/photos/2340/1050J1/1050J1_032.jpg",
        "https://m8g3z9g9.ssl.hwcdn.net/photos/2340/1050J1/1050J1_033.jpg"
      ],
      spin: "https://m8g3z9g9.ssl.hwcdn.net/photos/2340/1050J1/1050J1_033.jpg",
      currentVideo: undefined,
      currentImages: undefined,
      videoLoad: true,
      ifSubmitSuccess: false,
      page: 0,
      imagePage: 0,
      isVideoPlay: false,
      isPlay: false,
      ifMobileReqest: false,
      statusNT: false
    };
  },
  mounted() {
    document.body.classList.add("open-popup");
    if (window.innerWidth < 992) {
      if (window.orientation === 90) {
        this.navigation = true;
        this.pagination = false;
      } else {
        this.navigation = false;
        this.pagination = true;
      }
    }
  },
  destroyed() {
    document.body.classList.remove("open-popup");
  },
  methods: {
    changeType(type) {
      this.sectionType = type;
    },
    changeNTStatus(value) {
      this.statusNT = value;
    },
    submitForm() {
      this.ifSubmitSuccess = true;
    },
    onError() {
      this.videoLoad = false;
    },
    closePlayer() {
      document.body.classList.remove("open-popup");
      document.querySelector(".popup-wrapper").style.display = "none";
    },
    goToSingleVideo(index) {
      this.page = index;
      this.changeType(4);
    },
    goToSingleImage(index) {
      this.imagePage = index;
      this.changeType(5);
    },
    onPlay(value) {
      this.isVideoPlay = value;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Player.vue